<div>
  <ui-panel>
    <ui-panel-body>
      <ng-container
        *ngTemplateOutlet="
          list;
          context: {
            title: includedTitle,
            items: included,
            fallbackIcon: './assets/images/check-icon-v2.svg'
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          list;
          context: {
            title: excludedTitle,
            items: excluded,
            fallbackIcon: './assets/images/close-grey-v2.svg'
          }
        "
      ></ng-container>
    </ui-panel-body>
  </ui-panel>
  <ui-panel *ngIf="deviceExcluded" class="mt-6">
    <ui-panel-body>
      <p class="text--center">{{ deviceExcluded }}</p>
    </ui-panel-body>
  </ui-panel>
</div>

<ng-template
  #list
  let-title="title"
  let-items="items"
  let-fallbackIcon="fallbackIcon"
>
  <h3>{{ title }}</h3>
  <ul>
    <li *ngFor="let item of items; let i = index">
      <div
        class="icon--md icon-container mr-6"
        [ngClass]="{ 'icon-container--fallback': !item.icon }"
      >
        <img [src]="item.icon || fallbackIcon" />
      </div>
      <span>{{ item.text }}</span>
    </li>
  </ul>
</ng-template>
